import { Badge } from "antd";
import DynamicRoutingLayout from "../components/atoms/DynamicRoutingLayout";
import {
  Dot,
  GhostCalendar,
  GhostMarketing,
  GhostOrderList,
  GhostSetting,
} from "../components/organisms/Icon";
import { lnbIconRender } from "../components/organisms/Layout/Menus/utils/iconRender";
import { ItemType, LinkType } from "../components/organisms/Layout/constants";
import SinglePageLayout from "../components/organisms/SinglePageLayout";
import { TabPageLayout } from "../components/organisms/TabPageLayout";
import AppConfirm from "../pages/AppConfirm";
import FAQ from "../pages/FAQ";
import Inquiry from "../pages/Inquiry";
import Login from "../pages/Login";
import NoticePage from "../pages/Notice";
import NoticeDetail from "../pages/NoticeDetail";
import PwdReset from "../pages/PwdReset";
import ReRegister from "../pages/ReRegister";
import Register from "../pages/Register";
import ReservationManager from "../pages/Reservation";
import SpeedMateReservationManager from "../pages/Reservation/SpeedMate";
import ReservationConfig from "../pages/ReservationConfig";
import ReservationDetailPage from "../pages/ReservationDetail";
import ReviewManangement from "../pages/Review";
import ReviewDetail from "../pages/ReviewDetail";
import { UnbookablePage } from "../pages/Unbookable";
import UserInfo from "../pages/UserInfo";
import { PATH, autoOasisCodeQuery, speedMateQuery } from "./constants/path";
import SettlementManager from "../pages/Settlement";
import SettlementDetail from "../pages/Settlement/Detail";
import LaborFee from "../pages/LaborFee";
import LaborFeeRoute from "./LaborFeeRoute";

export const array: ItemType[] = [
  {
    mainLink: {
      name: "예약관리",
      icon: lnbIconRender({ icon: GhostCalendar }),
    },
    subLink: [
      {
        name: "예약현황",
        path: "/reservations",
        component: <ReservationManager />,
      },
      {
        name: "예약설정",
        path: "/reservation-config",
        badge: true,
        component: (
          <TabPageLayout
            tabMenu={[
              {
                label: "예약정보",
                key: "config",
                style: {
                  marginTop: 48,
                },
                children: (
                  <SinglePageLayout
                    menu="예약관리 > 예약설정"
                    smallMenu="예약정보"
                  >
                    <ReservationConfig />
                  </SinglePageLayout>
                ),
              },
              {
                label: (
                  <Badge count={<Dot fill="red" />} offset={[8, 0]}>
                    예약 불가 설정
                  </Badge>
                ),
                key: "unbookable",
                style: { marginTop: 48 },
                children: (
                  <SinglePageLayout
                    menu="예약관리 > 예약설정"
                    smallMenu="예약 불가 설정"
                  >
                    <UnbookablePage />
                  </SinglePageLayout>
                ),
              },
            ]}
          />
        ),
      },
    ],
  },
  {
    mainLink: {
      name: "정산관리",
      icon: lnbIconRender({ icon: GhostSetting }),
      path: "/settlement",
      component: <SettlementManager />,
    },
    subLink: [
      {
        name: "",
        path: "/settlement/:id",
        component: (
          <SinglePageLayout>
            <DynamicRoutingLayout
              navTarget="/settlement"
              menu="정산관리 > 정산 상세"
              smallMenu="정산 상세"
            >
              <SettlementDetail />
            </DynamicRoutingLayout>
          </SinglePageLayout>
        ),
      },
    ],
  },
  {
    mainLink: {
      name: "오일 및 패드 공임표",
      icon: lnbIconRender({ icon: GhostOrderList }),
      path: PATH.LABOR_FEE,
      component: (
        <LaborFeeRoute>
          <SinglePageLayout smallMenu="오일 및 패드 공임표">
            <LaborFee />
          </SinglePageLayout>
        </LaborFeeRoute>
      ),
    },
    subLink: [],
  },
  {
    mainLink: {
      name: "설정",
      icon: lnbIconRender({ icon: GhostSetting }),
    },
    subLink: [
      {
        name: "매장정보",
        path: "/user-management",

        component: (
          <SinglePageLayout menu="설정" smallMenu="매장정보">
            <UserInfo />
          </SinglePageLayout>
        ),
      },
      {
        name: "리뷰관리",
        path: "/review-manangement",
        component: (
          <SinglePageLayout menu="설정" smallMenu="리뷰관리">
            <ReviewManangement />
          </SinglePageLayout>
        ),
      },
      {
        name: "",
        path: "/review-manangement/:id",
        component: (
          <SinglePageLayout>
            <DynamicRoutingLayout
              navTarget="/review-manangement"
              menu="설정>리뷰관리"
              smallMenu="리뷰 상세"
            >
              <ReviewDetail />
            </DynamicRoutingLayout>
          </SinglePageLayout>
        ),
      },
    ],
  },
  {
    mainLink: {
      name: "고객센터",
      icon: lnbIconRender({ icon: GhostMarketing }),
    },
    subLink: [
      {
        name: "공지사항",
        path: "/notices",
        component: (
          <SinglePageLayout>
            <NoticePage />
          </SinglePageLayout>
        ),
      },
      {
        name: "",
        path: "/notices/:id",
        component: (
          <SinglePageLayout>
            <DynamicRoutingLayout
              navTarget="/notices"
              menu="고객센터>공지사항"
              smallMenu="공지사항 상세"
            >
              <NoticeDetail />
            </DynamicRoutingLayout>
          </SinglePageLayout>
        ),
      },
      {
        name: "FAQ",
        path: "/faq/",
        component: (
          <SinglePageLayout>
            <FAQ />
          </SinglePageLayout>
        ),
      },
      {
        name: "1:1문의",
        path: "/inquiry",
        component: (
          <SinglePageLayout>
            <Inquiry />
          </SinglePageLayout>
        ),
      },
    ],
  },
];

export const LinkArray: LinkType[] = [];

for (let i = 0; i < array.length; i += 1) {
  if (array[i].mainLink.component) {
    LinkArray.push(array[i].mainLink as LinkType);
  }
  for (let j = 0; j < array[i].subLink.length; j += 1) {
    LinkArray.push(array[i].subLink[j]);
  }
}
export const notAuthArray: LinkType[] = [
  { path: "/login", component: <Login />, name: "로그인" },
  { path: PATH.LOGIN, component: <Login />, name: "로그인" },
  { path: PATH.REGISTER, component: <Register />, name: "신청" },
  { path: PATH.PWD_RESET, component: <PwdReset />, name: "비번변경" },
  { path: PATH.RE_REGISTER, component: <ReRegister />, name: "재신청" },
  { path: PATH.APP_CONFIRM, component: <AppConfirm />, name: "앱확인" },
];

export const speedMate: ItemType[] = [
  {
    mainLink: {
      name: "예약관리",
      icon: lnbIconRender({ icon: GhostCalendar }),
    },
    subLink: [
      {
        name: "예약현황",
        path: PATH.SPEED_MATE_RESERVATION,
        component: (
          <SinglePageLayout>
            <SpeedMateReservationManager />
          </SinglePageLayout>
        ),
      },
      {
        name: "",
        path: `${PATH.SPEED_MATE_RESERVATION}/:id`,
        component: (
          <SinglePageLayout>
            <DynamicRoutingLayout
              navTarget={PATH.SPEED_MATE_RESERVATION}
              menu="예약관리>예약현황"
              smallMenu="예약현황 상세"
              defaultQuery={speedMateQuery}
            >
              <ReservationDetailPage />
            </DynamicRoutingLayout>
          </SinglePageLayout>
        ),
      },
    ],
  },
  {
    mainLink: {
      name: "고객센터",
      icon: lnbIconRender({ icon: GhostMarketing }),
    },
    subLink: [
      {
        name: "공지사항",
        path: "/speed-mate/notices",
        component: (
          <SinglePageLayout>
            <NoticePage />
          </SinglePageLayout>
        ),
      },
      {
        name: "",
        path: "/speed-mate/notices/:id",
        component: (
          <SinglePageLayout>
            <DynamicRoutingLayout
              navTarget="/speed-mate/notices"
              menu="고객센터>공지사항"
              smallMenu="공지사항 상세"
            >
              <NoticeDetail />
            </DynamicRoutingLayout>
          </SinglePageLayout>
        ),
      },
    ],
  },
];

export const speedMateArray: LinkType[] = [];

for (let i = 0; i < speedMate.length; i += 1) {
  if (speedMate[i].mainLink.component) {
    speedMateArray.push(speedMate[i].mainLink as LinkType);
  }
  for (let j = 0; j < speedMate[i].subLink.length; j += 1) {
    speedMateArray.push(speedMate[i].subLink[j]);
  }
}

export const autoOasis: ItemType[] = [
  {
    mainLink: {
      name: "예약관리",
      icon: lnbIconRender({ icon: GhostCalendar }),
    },
    subLink: [
      {
        name: "예약현황",
        path: PATH.AUTO_OASIS_RESERVATION,
        component: (
          <SinglePageLayout>
            <SpeedMateReservationManager />
          </SinglePageLayout>
        ),
      },
      {
        name: "",
        path: `${PATH.AUTO_OASIS_RESERVATION}/:id`,
        component: (
          <SinglePageLayout>
            <DynamicRoutingLayout
              navTarget={PATH.AUTO_OASIS_RESERVATION}
              menu="예약관리>예약현황"
              smallMenu="예약현황 상세"
              defaultQuery={autoOasisCodeQuery}
            >
              <ReservationDetailPage />
            </DynamicRoutingLayout>
          </SinglePageLayout>
        ),
      },
      {
        name: "예약설정",
        path: "/autooasis/reservation-config",
        badge: true,
        component: (
          <TabPageLayout
            tabMenu={[
              {
                label: "예약정보",
                key: "config",
                style: {
                  marginTop: 48,
                },
                children: (
                  <SinglePageLayout
                    menu="예약관리 > 예약설정"
                    smallMenu="예약정보"
                  >
                    <ReservationConfig />
                  </SinglePageLayout>
                ),
              },
              {
                label: (
                  <Badge count={<Dot fill="red" />} offset={[8, 0]}>
                    예약 불가 설정
                  </Badge>
                ),
                key: "unbookable",
                style: { marginTop: 48 },
                children: (
                  <SinglePageLayout
                    menu="예약관리 > 예약설정"
                    smallMenu="예약 불가 설정"
                  >
                    <UnbookablePage />
                  </SinglePageLayout>
                ),
              },
            ]}
          />
        ),
      },
    ],
  },
  {
    mainLink: { name: "설정", icon: lnbIconRender({ icon: GhostSetting }) },
    subLink: [
      {
        name: "매장정보",
        path: "/autooasis/user-management",

        component: (
          <SinglePageLayout menu="설정" smallMenu="매장정보">
            <UserInfo />
          </SinglePageLayout>
        ),
      },
    ],
  },
  {
    mainLink: {
      name: "고객센터",
      icon: lnbIconRender({ icon: GhostMarketing }),
    },
    subLink: [
      {
        name: "공지사항",
        path: "/autooasis/notices",
        component: (
          <SinglePageLayout>
            <NoticePage />
          </SinglePageLayout>
        ),
      },
      {
        name: "",
        path: "/autooasis/notices/:id",
        component: (
          <SinglePageLayout>
            <DynamicRoutingLayout
              navTarget="/autooasis/notices"
              menu="고객센터>공지사항"
              smallMenu="공지사항 상세"
            >
              <NoticeDetail />
            </DynamicRoutingLayout>
          </SinglePageLayout>
        ),
      },
    ],
  },
];

export const autoOasisArray: LinkType[] = [];

for (let i = 0; i < autoOasis.length; i += 1) {
  if (autoOasis[i].mainLink.component) {
    autoOasisArray.push(autoOasis[i].mainLink as LinkType);
  }
  for (let j = 0; j < autoOasis[i].subLink.length; j += 1) {
    autoOasisArray.push(autoOasis[i].subLink[j]);
  }
}
